import RetailModel from 'app/src/data/models/RetailModel';
import URLHelper from 'app/src/data/models/utils/URLHelper';

const _AccountType = {
  TEST: 'test',
  DEMO: 'demo',
  CUSTOMER: 'customer',
};

export default class Account extends RetailModel {
  /**
   * Expose the account types as a property on the class.
   */
  static get AccountType() {
    return _AccountType;
  }

  /**
   * The attribute that maps to the model's unique ID
   * */
  get idAttribute() {
    return 'systemCustomerID';
  }

  /**
   * Defaults to use for model properties.
   */
  get defaults() {
    return {
      status: 'test',
    };
  }

  /**
   * Return the url for the Sale endpoint
   */
  url() {
    let URL = URLHelper.getURL('/Account');
    if (!this.isNew()) {
      URL += `/${this.id}`;
    }
    return `${URL}.json`;
  }
}
